import React from "react";
import { Navbar, Footer } from "./components";
import ParallaxV6TestingScreen from "./testing/ParallaxV6TestingScreen";

const App = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="gradient-bg-welcome flex flex-col notranslate" translate="no">
        <Navbar />
        <ParallaxV6TestingScreen />
      </div>
      <Footer />
    </div>
  );
};

export default App;
